module.exports = __webpack_public_path__ + "img/Weapon_49.bffcea20.png";